import AddIcon from '@mui/icons-material/Add';
import { Box, useTheme } from "@mui/material";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import { tokens } from "../../../../../theme";
// import { getAllStock } from "../../../../api/warehouse/stock";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { WarehouseStockCard } from "../../../../../components/global/cards/products/StockCard";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import ShCopyButton from "../../../../../components/theme/ShCopy";
import SidepanelLoader from '../../../../../components/theme/sidepanel2/SidepanelLoader';
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import Text from "../../../../../components/theme/text/Text";
import { useGetBatchesQuery } from "../../../../../newapi/batch/batchSlice";
import { BATCH_FILTER_KEYS } from '../../../../../components/global/DataGrid/Filter';
import { ProductBatchCard } from '../../../../../components/global/cards/stock/BatchCard';

const SpBatchDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpBatchDetails/SpBatchDetails"));
const SpStockDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpStockDetails/SPStockDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    return <></>
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [BATCH_FILTER_KEYS.RELATION, BATCH_FILTER_KEYS.PRODUCT],
};

const Batches = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
    const [isExtended, setIsExtended] = useState(false);
    const [spBatchLoading, setSpBatchLoading] = useState();
    
    const [batchId, setBatchId] = useState();
    const batchIdRef = useRef(batchId);
    
    const getBatchDetails = (params) => {
        if (!params) return;
        if (!isFulfilment) return;
    
        const newBatchId = parseInt(params.row.id);
        // Only update state if the productId has actually changed
        if (batchIdRef.current !== newBatchId) {
            if(!spBatchLoading){
                setSpBatchLoading(true);
            }
            setBatchId(newBatchId);
            batchIdRef.current = newBatchId; // Update the ref to the new value
        }
        
        setIsExtended(true);
    };

    const [stockIsExtended, setStockIsExtended] = useState(false);
    const [spStockLoading, setSpStockLoading] = useState();
    
    const [productId, setProductId] = useState();
    const productIdRef = useRef(productId);
    
    const getProductDetails = (productId) => {
        if (!productId) return;
    
        const newProductId = parseInt(productId);
        // Only update state if the productId has actually changed
        if (productIdRef.current !== newProductId) {
            if(!spStockLoading){
                setSpStockLoading(true);
            }
            setProductId(newProductId);
            productIdRef.current = newProductId; // Update the ref to the new value
        }
        setStockIsExtended(true);
    };

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
            
        }
    },[]);

    const columns = [
        {
            field: "number",
            headerName: t("number"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.number;
            }
        },
        {
            field: "barcode",
            headerName: t("barcode"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.barcode;
            }
        },
        {
            field: "bbDate",
            headerName: t("tht"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = new Date(params.row.bbDate);
                let now = new Date();
                let diffTime = date.getTime() - now.getTime();
                let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                
                let labelcolor = "primary";
                if (diffDays <= 30) {
                    labelcolor = "red";
                } else if (diffDays <= 60) {
                    labelcolor = "orange";
                }
              
                return (
                    <ShLabel clickable size={32} fitted variant={labelcolor} palette="normal">{date.toLocaleDateString(i18n.language)}</ShLabel>
                );
            },
        },
        {
            field: "sku",
            headerName: t("sku"),
            flex:1,
            filter: BATCH_FILTER_KEYS.PRODUCT,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                const handleClick = (event) => {
                    event.stopPropagation(); // Prevent click from propagating to the row
                    getProductDetails(params.row.productId);
                };

                return (
                    <Box onClick={handleClick}
                     sx={{
                        width:1,
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.sku}</Text>
                    </Box>
                );
            }
        },
        {
            field: "description",
            headerName: t("description"),
            flex:3,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.description;
            }
        },
        ...isFulfilment ? [{
            field: "relation",
            headerName: t("relation"),
            flex:1,
            filter: BATCH_FILTER_KEYS.RELATION,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.relation ?? t("unknown")
            },
        }] : [],
        {
            field: "stock_available",
            headerName: t("stock_available"),
            flex:1,
            shFilter: {
                type: "number"
            },
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.total_available
            },
        },
        {
            field: "total_quantity",
            headerName: t("stock_quantity"),
            flex:1,
            shFilter: {
                type: "number"
            },
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.total_quantity
            },
        },
        {
            field: "dateReceived",
            headerName: t("date_received"),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = new Date(params.row.dateReceived);
              
                return (
                    <Text>
                        {date.toLocaleDateString(i18n.language)}
                    </Text>
                );
            },
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <ProductBatchCard 
                        skeleton={params.row.skeleton ?? false}
                        {...params.row}
                        onClick={() => getBatchDetails(params)}
                    />
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            <ShDataGrid2
                key={theme.palette.mode}
                content={useGetBatchesQuery}
                // gridActions={<GridActions></GridActions>} 
                title={t('overview')}
                gridOptions={gridOptions}
                onRowClick={getBatchDetails}
                sortModel={{field: columns[8].field,type:"DESC"}}
                columns={columns}
            />
            {spStockLoading && 
                <SpStockDetails
                    isExtended={stockIsExtended}
                    setIsExtended={setStockIsExtended}
                    productId={productId}
                />
            }
            {spBatchLoading && 
                <SpBatchDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    batchId={batchId}
                />
            }
        </Box>
    );
};
export default Batches;